import { useState, useEffect, useRef } from 'react'

const useLoading = (bool, delay=1000) => {
  const [isLoading, setIsLoading] = useState(bool)
  const [isLoadingDelayed, setIsLoadingDelayed] = useState(false)
  const timeout = useRef()

  useEffect(() => {
    if (isLoading === true) {
      timeout.current = setTimeout(() => {
        setIsLoadingDelayed(true)
      }, delay)
    } else {
      clearTimeout(timeout.current)
      setIsLoadingDelayed(false)
    }
    return () => {
      clearTimeout(timeout.current)
      setIsLoadingDelayed(false)
    }
  }, [isLoading])

  return { isLoading, isLoadingDelayed, setIsLoading }
}

export default useLoading
